import FqApi from '@/services/fq-api'

const baseUrl = '/quotes'

export default {
  async getGeneralImageCategory() {
    const url = `${baseUrl}/images/generalcategory`
    return (await FqApi.get(url)).data
  },
  async getQuoteImageCategories() {
    const url = `${baseUrl}/images/categories/list`
    return (await FqApi.get(url)).data
  }
}
